<template>
  <page-view title="系统运行状态">
    <a-row :gutter="16">
      <a-col class="s-col" :span="12">
        <a-card title="内存用量">
          <div>
            <span class="s-text">
              JVM物理内存 ( {{ memUsed }} M / {{ memTotal }} M)
            </span>
            <a-progress :percent="memPct"/>
          </div>
          <br/>
          <div>
            <span class="s-text">
              JVM Heap内存 ( {{ heapUsed }} M / {{ heapTotal }} M)
            </span>
            <a-progress :percent="heapPct"/>
          </div>
          <br/>
          <div>
            <span class="s-text">初始堆（-Xms）</span>
            <span class="s-text s-floatR">{{ heapInit }}M</span>
          </div>
          <br/>
          <div>
            <span class="s-text">最大堆（-Xms）</span>
            <span class="s-text s-floatR">{{ heap }}M</span>
          </div>
        </a-card>
      </a-col>
      <a-col class="s-col" :span="12">
        <a-card title="JVM信息">
          <div>
            <span class="s-text">java安装目录</span>
            <span class="s-text s-floatR">{{ data.sysInfo['java.home'] }}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">java版本</span>
            <span class="s-text s-floatR">{{data.sysInfo['java.version']}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">操作系统</span>
            <span class="s-text s-floatR">{{data.sysInfo['os.name']}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">最大 / 可用内存</span>
            <span class="s-text s-floatR">{{ data.maxMemory }} MB / {{ data.freeMemory }} MB</span>
          </div>
          <br/>
          <br/>
        </a-card>
      </a-col>
      <a-col class="s-col" :span="12">
        <a-card title="系统信息">
          <div>
            <span class="s-text">应用服务器</span>
            <span class="s-text s-floatR">{{data.sc.tomcatVersion}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">工作目录</span>
            <span class="s-text s-floatR">{{data.sc.tomcatPath}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">会话超时（Session Timeout）</span>
            <span class="s-text s-floatR">{{data.sc.maxInactiveInterval / 60}}分钟</span>
          </div>
          <br/>
          <div>
            <span class="s-text">缓存管理</span>
            <span class="s-text s-floatR">{{data.cache}}</span>
          </div>
          <br/>
        </a-card>
      </a-col>
      <a-col v-if="data.license.show" class="s-col" :span="12">
        <a-card title="授权信息">
          <div>
            <span class="s-text">授权使用</span>
            <span class="s-text s-floatR">{{data.license.company}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">授权IP</span>
            <span class="s-text s-floatR">{{data.license.ip ? data.license.ip : '无限制'}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">授权日期</span>
            <span class="s-text s-floatR">{{data.license.createdAt}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">结束日期</span>
            <span class="s-text s-floatR">{{data.license.expiresAt}}</span>
          </div>
          <br/>
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="16">
      <a-col class="s-col" :span="12">
        <a-card title="主数据库信息">
          <div>
            <span class="s-text">数据库名称</span>
            <span class="s-text s-floatR">{{data.database.productName}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">数据库版本</span>
            <span class="s-text s-floatR">{{data.database.productVersion}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">驱动名称</span>
            <span class="s-text s-floatR">{{data.database.driverVersion}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">数据库连接池</span>
            <span class="s-text s-floatR">{{data.database.poolName}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">最大活跃连接数</span>
            <span class="s-text s-floatR">{{data.database.maxActive}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">最小空闲连接数</span>
            <span class="s-text s-floatR">{{data.database.minIdle}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">获取连接等待时间</span>
            <span class="s-text s-floatR">{{data.database.maxWait}}</span>
          </div>
          <br/>
          <div>
            <span class="s-text">连接泄露检测</span>
            <span class="s-text s-floatR">{{data.database.leakDetectionThreshold}}</span>
          </div>
          <br/>
        </a-card>
      </a-col>
    </a-row>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'

export default {
  name: 'StatusIndex',
  components: {
    PageView
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      data: {
        metrics: {},
        cache: {},
        database: {},
        license: {},
        sc: {},
        sysInfo: {}
      },
      memTotal: 0,
      memFree: 0,
      memUsed: 0,
      memPct: 0,
      heapInit: 0,
      heap: 0,
      heapTotal: 0,
      heapUsed: 0,
      heapPct: 0
    }
  },
  methods: {
    init () {
      const that = this
      this.$http.get('/api/1/status/info.json').then(function (response) {
        if (response.code !== 200) {
          return
        }
        if (response.result) {
          // jvm物理内存
          that.data = response.result
          that.memTotal = parseInt(
            parseFloat(that.data.metrics.mem) / 1024 / 1024
          )
          that.memFree = parseInt(
            parseFloat(that.data.metrics['mem.free']) / 1024 / 1024
          )
          that.memUsed = parseInt(that.memTotal - that.memFree)
          that.memPct = parseInt(
            (parseFloat(that.memUsed) / parseFloat(that.memTotal)) * 100
          )
          // jvm heap内存
          that.heapInit = parseInt(
            parseFloat(that.data.metrics['heap.init']) / 1024 / 1024
          )
          that.heap = parseInt(
            parseFloat(that.data.metrics.heap) / 1024 / 1024
          )
          that.heapTotal = parseInt(
            parseFloat(that.data.metrics['heap.committed']) / 1024 / 1024
          )
          that.heapUsed = parseInt(
            parseFloat(that.data.metrics['heap.used']) / 1024 / 1024
          )
          that.heapPct = parseInt(
            (parseFloat(that.heapUsed) / parseFloat(that.heapTotal)) * 100
          )
        }
      })
    }
  }
}
</script>

<style scoped>
.s-text {
  color: #000;
  font-size: 16px;
}

.s-floatR {
  float: right;
}

.s-col {
  margin-top: 10px;
}
</style>
